import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { globalTranslationKeys } from '../../enums';
import { useClickOutside } from '../../hooks/useClickOutside';
import { autoBetCountList, autoBetDataKeys } from '../../enums/uiConfig';

export const AutoBetSection = observer(
  ({
    t,
    isStart,
    fighterData,
    autoBetData,
    doBetSender,
    handleChangeAutoBet,
    currentFighterSection,
    updateIsDisabledBetSection,
  }) => {
    const [ref, hasOutsideClick] = useClickOutside();
    const { isAutoBet, isOpened, autoBetCount } = autoBetData;

    const handleOpenAutoBetCountList = () => {
      if (isAutoBet) {
        handleChangeAutoBet(autoBetDataKeys.isAutoBet, false, currentFighterSection);
        handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0, currentFighterSection);
        updateIsDisabledBetSection(false);
      } else if (isOpened && !isAutoBet) {
        handleChangeAutoBet(autoBetDataKeys.isOpened, false, currentFighterSection);
      } else {
        handleChangeAutoBet(autoBetDataKeys.isOpened, true, currentFighterSection);
      }
    };

    const handleClickAutoBetCount = (item) => {
      handleChangeAutoBet(autoBetDataKeys.autoBetCount, Number(item), currentFighterSection);
      handleChangeAutoBet(autoBetDataKeys.isAutoBet, true, currentFighterSection);
      handleChangeAutoBet(autoBetDataKeys.isOpened, false, currentFighterSection);
      if (isStart) {
        isStart && !fighterData.isBetAccepted && doBetSender(currentFighterSection);
      } else {
        // gameStore.autoUpdatedCurrentSection();
        !fighterData.isBetAccepted && updateIsDisabledBetSection(true, currentFighterSection);
      }
    };

    useEffect(() => {
      if (hasOutsideClick && !isAutoBet) {
        handleChangeAutoBet(autoBetDataKeys.isOpened, false, currentFighterSection);
        handleChangeAutoBet(autoBetDataKeys.isAutoBet, false, currentFighterSection);
        handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0, currentFighterSection);
      }
    }, [hasOutsideClick, isAutoBet]);

    return (
      <div className='bet-left-row-cont' ref={ref}>
        <div className='container-left-circle-text'>
          {isOpened ? (
            <div className='bet-cof-container'>
              {autoBetCountList.map((count) => (
                <div
                  className='around-cof'
                  key={count}
                  onClick={() => {
                    handleClickAutoBetCount(count);
                  }}
                >
                  <span className='text-around-cof'>{count || ''}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className='bet-left-row-text'>{t(globalTranslationKeys.AutoBet)}</p>
          )}
          {isAutoBet && autoBetCount ? (
            <div className='circle-future-icon-cont'>
              <span className='circle-future-text'>{autoBetCount}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* ADD CLASS " active " */}
        <div
          className={`bet-switcher ${isAutoBet || isOpened ? 'active' : ''}`}
          onClick={handleOpenAutoBetCountList}
        >
          <div className='bet-switcher-inner'>
            <div className='circle-bet-switcher-inner'>
              <div className='circle-bet-switcher-inner-bg'>
                <div className='small-circle-center' />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
